import * as Yup from 'yup';

export const materialListSchema = Yup.object({
  Description: Yup.string().required('Description is required'),
});
